import { TopExperienceDataDto } from '@repo/shared/dtos/analytics/AnalyticsResponseDto';

export interface TopExperiencePieDatum {
  id: string;
  label: string;
  value: number;
  percentage: number;
  sessions: number;
  minutes: number;
  color: string;
}

export const buildTopExperiencePieData = (
  data: TopExperienceDataDto[],
  showMetric: 'sessions' | 'minutes',
): TopExperiencePieDatum[] => {
  return data.map((experience, index) => ({
    id: experience.experienceTitle,
    label:
      experience.experienceTitle.length > 15
        ? `${experience.experienceTitle.substring(0, 15)}...`
        : experience.experienceTitle,
    value: showMetric === 'minutes' ? experience.totalMinutes : experience.sessionCount,
    percentage: experience.percentage,
    sessions: experience.sessionCount,
    minutes: Math.round(experience.totalMinutes),
    color: `hsl(${200 + index * 15}, 65%, ${55 - index * 2}%)`,
  }));
};
